import React, { useContext } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import { FormattedMessage } from 'react-intl';
import { CusButton } from '../../Components/From/Button';
import { Global } from '../../App';

import './Error.scss';
import { withRouter } from 'react-router';
import { useMemo } from 'react';

function Error({
  onBack,
  errCode,
  errMessage,
  ...props
}) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const { state } = props.location;
  // 防止直接進入此頁面
  // if (!state || !state.verify) {
  //   dispatchGlobal({ type: 'RESET' });
  //   props.history.replace('/');
  //   return null
  // }

  const $errCode = useMemo(() => {
    if (errCode !== undefined) {
      return `${errCode}`
    }
    return `${globalState.errMsg}`
  }, [errCode, globalState.errMsg])
  return (
    <>
      <Header
        props={props}
        menuItems={[
          { title: '我要點餐', path: '/' },
          { title: '絕頂美味', path: '/error' }
        ]}
      />
      <div className="error d-flex col flex-column justify-content-between p-0">
        <div className="d-flex flex-column w-100 col p-0 pt-3">
          <div className="d-flex flex-column align-items-center">
            <h1 className="mb-5 error__title">
              <FormattedMessage id="pages.error.title" />
            </h1>
            <span className="mb-5 error__subtitle">
              <FormattedMessage id="pages.error.subtitle" />
            </span>
          </div>
          <div className="error__context d-flex flex-column col align-items-center justify-content-between pt-5 pb-5">
            {errCode !== 999 ? (
              <span className="mb-5">
                {/* {errCode ? ( */}
                <FormattedMessage
                  id={`errorMsg.errorCode_${$errCode || globalState.errMsg}`}
                />
                {/* ) : null} */}
                {/* <div>{errMessage}</div> */}
                <div dangerouslySetInnerHTML={{ __html: errMessage }}></div>
              </span>
            ) : (
              // <div>{errMessage}</div>
              <div dangerouslySetInnerHTML={{ __html: errMessage }}></div>
            )}

            <CusButton.White
              className="p-3 pr-5 pl-5 error-page-back"
              children={<FormattedMessage id="pages.error.buttonBack" />}
              onClick={e => {
                if (onBack !== undefined) {
                  console.debug(errCode);
                  if(globalState.staffInfo.currentCheckOrderStep === "3" && errCode == 415){                 
                    dispatchGlobal({
                      type: "UPDATE",
                      payload: [
                        {
                          key: "staffInfo",
                          val: {
                            ...globalState.staffInfo,
                            checkOrderData:null,
                            orderCode:null,                          
                            currentCheckOrderStep: "1",
                            prevPath:null
                          },
                        },
                      ],
                    });
                    props.history.push("/staffSearchOrder");
                  }
                  else{
                    onBack();
                  }
                } else {
                  props.history.goBack();
                }

                // dispatchGlobal({
                //   type: 'UPDATE',
                //   payload: [{ key: 'errMsg', val: null }]
                // });
              }}
            />
          </div>
        </div>
        <div className="w-100">
          <Footer />
        </div>
      </div>
    </>
  );
}

export default withRouter(Error);
